import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { KlAlertService } from "@app/modules/shared/services/message/alert.service";
import { Alert } from "@app/modules/shared/enum/alert-type";

@Component({
  selector: "kl-alert",
  templateUrl: "./kl-alert.component.html",
  styleUrls: ["./kl-alert.component.scss"],
})
export class KlAlertComponent implements OnInit {
  alerts: Alert[] = [];
  @Input() message: string;
  @Input() type: string;
  @Input() show: boolean;
  @Output() onClose = new EventEmitter<any>();

  constructor(private alertService: KlAlertService) {}

  ngOnInit() {
    this.alertService.getAlert().subscribe((alert: Alert) => {
      this.alerts = [];
      this.alerts.push(alert);
    });
    // this.alerts = [];
    //   this.alerts.push({
    //     message: this.message,
    //     type: this.type
    //   });
  }

  removeAlert() {
    // this.alerts = this.alerts.filter(x => x !== alert);
    this.onClose.emit();
  }

  iconClass(alert) {
    if (!alert) {
      return;
    }
    switch (alert) {
      case "success":
        return "fa-check";
      case "error":
        return "fa-exclamation-circle";
      case "info":
        return "fa-info-circle";
      case "warning":
        return "fa-exclamation-triangle";
    }
  }
}
